module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-fr-FR.6ee244fe.jpg";